import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import VerifyEmail, { IVerifyEmailDispatchProps, IVerifyEmailStateProps } from './VerifyEmail'
import { verifyEmailCode, resendVerificationCode } from './store/VerifyEmailActions'
import {
  getVerifyEmailLoading,
  getVerifyEmailError,
  getVerifyEmailResending,
  getVerifyEmailPurpose,
  getVerifyEmailEmail,
} from './store/VerifyEmailSelectors'
import { doLogOut } from '../../common/auth/authActions'

const mapStateToProps = (state: IGlobalState): IVerifyEmailStateProps => ({
  loading: getVerifyEmailLoading(state),
  error: getVerifyEmailError(state),
  resending: getVerifyEmailResending(state),
  purpose: getVerifyEmailPurpose(state),
  email: getVerifyEmailEmail(state),
})

const mapDispatchToProps: IVerifyEmailDispatchProps = {
  verifyEmailCode,
  resendVerificationCode,
  doLogOut,
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmail)
